import request from '@/utils/request';

export function getSysNavList(query) {
  return request({
    url: '/api/system/sysNav/querySysNavList',
    method: 'post',
    data: query
  });
}

export function getSysNav(query) {
  return request({
    url: '/api/system/sysNav/getSysNav',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/nav/index.js